// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SWh3","col":"styles_col__UjTOM"};